/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
/* eslint-disable comma-dangle */
import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import moment from 'moment';
import Table from '../../components/Table';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

function Transfers() {
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle
  );
  const location = useLocation();
  const id = location?.state?.id;
  const pond = location?.state?.pond;
  const searchText = location?.state?.searchText ?? '';

  const [cycles, setCycles] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const columns = [
    {
      title: 'Viveiro Origem',
      field: 'origin.pond.description',
      type: 'string',
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Viveiro Destino',
      field: 'destiny.pond.description',
      type: 'string',
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Quantidade',
      field: 'quantity',
      editable: 'never',
      hideFilterIcon: true,
      render: (rowData) => (
        <span>{new Intl.NumberFormat('pt-BR').format(rowData.quantity)}</span>
      ),
    },
    {
      title: 'Idade',
      field: 'old',
      editable: 'never',
      hideFilterIcon: true,
    },
    {
      title: 'Data',
      field: 'date',
      type: 'date',
      editable: 'never',
      dateSetting: { locale: 'pt-BR' },
      hideFilterIcon: true,
    },
    {
      title: 'Tipo de Transferencia',
      field: 'transfer_type',
      editable: 'never',
      hideFilterIcon: true,
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get(
          `/transfers/cycle-code/${selectedCycle.id}`,
          {
            params: id ? { cycle: id } : {},
          }
        );
        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          const data = await response.data;
          const organizedData = await data.map((_element) => ({
            date: moment(_element.date).format('DD/MM/YYYY'),
            old: _element.old,
            quantity: _element.quantity,
            'destiny.pond.description': _element.destiny.pond.description,
            'origin.pond.description': _element.origin.pond.description,
          }));
          setCycles(data);
          setExportData(organizedData);
          setOpenProgress(true);
        }
      } catch (err) {}
    }
    loadData();
  }, [selectedCycle]);

  function setData(newData) {
    const tempData = [];
    cycles.map((cycle) =>
      cycle.id === newData.id ? tempData.push(newData) : tempData.push(cycle)
    );
    setCycles(tempData);
  }

  // eslint-disable-next-line react/no-unstable-nested-components
  function CustomTitle() {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            fontWeight: 500,
            fontSize: '20px',
            fontFamily: 'Roboto',
            marginInlineEnd: '10px',
          }}
        >
          Transferências
        </div>
        {pond ? (
          <div
            style={{
              padding: '5px',
              marginLeft: 'auto',
              border: '1px solid black',
              borderRadius: '10px',
              fontWeight: 600,
            }}
          >
            {pond.description}
          </div>
        ) : null}
      </div>
    );
  }
  return (
    <Table
      title="Transferências"
      titleCustomized={<CustomTitle />}
      route="/transfers/"
      routeAdd="/transfer/"
      columns={columns}
      data={cycles}
      setData={setData}
      dataLoaded={openProgress}
      exportData={exportData}
      pond={pond}
      searchText={searchText}
    />
  );
}

export default Transfers;
